export function formatWorkerTypesLabel(
  workerTypes: readonly string[] | undefined
): string | undefined {
  if (!Array.isArray(workerTypes)) {
    return undefined;
  }

  const normalizedWorkerTypes = workerTypes.filter((workerType): workerType is string => {
    return typeof workerType === "string" && workerType.trim().length > 0;
  });

  if (normalizedWorkerTypes.length === 0) {
    return undefined;
  }

  if (normalizedWorkerTypes.length === 1) {
    return normalizedWorkerTypes[0];
  }

  return `${normalizedWorkerTypes[0]} + ${normalizedWorkerTypes.length - 1} more`;
}
